import { render, staticRenderFns } from "./PatientSurveyModal.vue?vue&type=template&id=20b58296"
import script from "./PatientSurveyModal.vue?vue&type=script&lang=js"
export * from "./PatientSurveyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports